import { Component } from '@angular/core';
import { SelectComponent } from 'angular6-json-schema-form';

@Component({
  selector: 'app-widget-select',
  templateUrl: './widget-select.component.html',
  styleUrls: ['./widget-select.component.scss'],
})
export class WidgetSelectComponent extends SelectComponent {
  public updateValue(event: { target: { value: string } }) {
    if (this.boundControl) {
      this.formControl.setValue(event.target.value);
    } else {
      super.updateValue(event);
    }
  }
}
